import React from "react";
import Navbar from "../../../components/Navbar";
import BackToTop from "../../../components/BackToTop";
import { Container, NavbarGroup, Content } from "../style";

const AIJourney_v1 = () => {
  return (
    <Container>
      <Container id="back-to-top-anchor" />
      <Navbar />

      <NavbarGroup aria-label="Conteúdo da página">
        <p>Índice</p>

        <ul>
          <li>
            <a href="#1">
              <span>
                <strong>1.</strong> A Promessa
              </span>
            </a>
          </li>

          <li>
            <a href="#2">
              <span>
                <strong>2.</strong> Qualificação das Partes
              </span>
            </a>
          </li>

          <li>
            <a href="#3">
              <span>
                <strong>3.</strong> Regras de Participação
              </span>
            </a>
          </li>

          <li>
            <a href="#4">
              <span>
                <strong>4.</strong> Como Solicitar o Reembolso
              </span>
            </a>
          </li>

          <li>
            <a href="#5">
              <span>
                <strong>5.</strong> Quando a Garantia Não se Aplica
              </span>
            </a>
          </li>

          <li>
            <a href="#6">
              <span>
                <strong>6.</strong> Tratamento de Dados Pessoais
              </span>
            </a>
          </li>

          <li>
            <a href="#7">
              <span>
                <strong>7.</strong> Disposições Gerais
              </span>
            </a>
          </li>

          <li>
            <a href="#resumo">
              <span>Resumo</span>
            </a>
          </li>
        </ul>
      </NavbarGroup>

      <Content>
        <h1 style={{ marginTop: 50 }}>AI Journey 2026 – Termo de Aceite</h1>

        <p>Garantia de ROI em 180 dias.</p>

        <p id="1">
          <strong>1. A PROMESSA:</strong>
        </p>
        <p>
          Se em 180 (cento e oitenta) dias o Participante não identificar uma ferramenta de IA,
          construir um time de agentes ou automatizar um processo utilizando IA que pague o
          investimento, a <strong>STARTSE</strong> devolverá 100% (cem por cento) do valor pago.
          Para tanto, é necessário o cumprimento integral das regras descritas neste documento.
        </p>
        <p>
          A garantia é real. Para que ela funcione, é indispensável que o Participante tenha
          efetivamente participado do programa. As regras a seguir asseguram que a{" "}
          <strong>STARTSE</strong> cumpriu sua parte e que o Participante cumpriu a dele.
        </p>

        <p id="2">
          <strong>2. QUALIFICAÇÃO DAS PARTES:</strong>
        </p>
        <p>
          2.1. <u>Contratada:</u> <strong>STARTSE</strong> Informações e Sistemas S.A., inscrita
          no CNPJ sob o nº 24.554.736/0001-70, com sede na Avenida das Nações Unidas, 12901 –
          CENU Torre Norte 9º Andar – Cidade Monções – São Paulo/SP, doravante denominada
          simplesmente <strong>STARTSE</strong>.
        </p>
        <p>
          2.2. <u>Contratante / Participante:</u> pessoa física ou jurídica identificada no ato
          da compra, cujos dados (nome completo ou razão social, CPF ou CNPJ, e-mail e telefone)
          constam no cadastro da plataforma da <strong>STARTSE</strong>, doravante denominada
          Participante.
        </p>

        <p id="3">
          <strong>3. REGRAS DE PARTICIPAÇÃO:</strong>
        </p>

        <p>
          <strong>3.1. Regra 1 — Participação mínima de 80% do programa.</strong>
        </p>
        <p>
          3.1.1. A participação é medida como média ponderada de 5 (cinco) frentes, conforme
          tabela abaixo:
        </p>

        <Container style={{ overflowX: "auto", margin: "16px 0" }}>
          <table>
            <thead>
              <tr>
                <th>Frente</th>
                <th>Peso</th>
                <th>O que conta</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Diagnóstico e Planejamento</td>
                <td>10%</td>
                <td>
                  Diagnóstico de Maturidade, Planejamento, entrega do AI Canvas e de 1 (um) caso
                  de uso selecionado
                </td>
              </tr>
              <tr>
                <td>Trilhas online (6 trilhas)</td>
                <td>35%</td>
                <td>Concluir os módulos na plataforma</td>
              </tr>
              <tr>
                <td>Imersões presenciais (2)</td>
                <td>10%</td>
                <td>Estar presente nos eventos (check-in)</td>
              </tr>
              <tr>
                <td>Encontros ao vivo: Radar IA, Elite Sessions, Mentorias técnicas</td>
                <td>30%</td>
                <td>Participar de pelo menos 8 (oito) dos 12 (doze) do ano</td>
              </tr>
              <tr>
                <td>Sessões com Concierge</td>
                <td>5%</td>
                <td>Realizar no mínimo 6 (seis) conversas 1:1 nos 6 (seis) meses</td>
              </tr>
              <tr>
                <td>Toolkit AI</td>
                <td>10%</td>
                <td>Utilizar pelo menos 10 (dez) agentes</td>
              </tr>
            </tbody>
          </table>
        </Container>

        <p>
          3.1.2. O Participante poderá faltar a uma imersão e ainda ter direito à garantia, desde
          que tenha pontuação suficiente nas demais frentes. O que importa é que a média
          ponderada atinja 80% (oitenta por cento) ao final dos 180 (cento e oitenta) dias.
        </p>

        <p>
          <strong>3.2. Regra 2 — Cumprimento dos 5 (cinco) marcos obrigatórios.</strong>
        </p>
        <p>
          3.2.1. O percentual de 80% (oitenta por cento) previsto na Regra 1 é uma média, sobre a
          qual o Participante tem flexibilidade de distribuição. Existem, porém, 5 (cinco) ações
          que precisam ser cumpridas individualmente, sem exceção. O descumprimento de qualquer
          um dos marcos abaixo extingue o direito à garantia, ainda que o Participante atinja 95%
          (noventa e cinco por cento) da participação geral.
        </p>
        <p>
          3.2.2. <u>Marco 1 — Diagnóstico de Maturidade:</u> o Participante deverá participar do
          assessment, fornecer as informações solicitadas e receber o relatório executivo da sua
          empresa, nos primeiros 30 (trinta) dias do programa.
        </p>
        <p>
          3.2.3. <u>Marco 2 — Roadmap de Adoção:</u> o Participante deverá participar das sessões
          de construção do roadmap, validar formalmente o documento (por assinatura ou e-mail de
          aceite) e ter ao menos 1 (um) quick win identificado para os 90 (noventa) dias
          seguintes, nos primeiros 60 (sessenta) dias do programa.
        </p>
        <p>
          3.2.4. <u>Marco 3 — Imersão Presencial:</u> o Participante deverá estar presente em
          pelo menos 1 (uma) das 2 (duas) imersões oferecidas no ano (IA para Negócios ou
          Multiagentes), com check-in no evento, em qualquer momento dentro dos 180 (cento e
          oitenta) dias.
        </p>
        <p>
          3.2.5. <u>Marco 4 — Sponsor C-Level:</u> o Participante deverá designar formalmente,
          por e-mail ou pelo Concierge, qual executivo (CEO, CIO, CFO, COO ou equivalente) é o
          patrocinador interno do programa na sua empresa, nos primeiros 30 (trinta) dias do
          programa.
        </p>
        <p>
          3.2.6. <u>Marco 5 — Encontros ao vivo:</u> o Participante deverá participar de pelo
          menos 10 (dez) encontros ao vivo distribuídos entre Elite Sessions, Mentorias e Radar
          de IA, ao longo dos 180 (cento e oitenta) dias.
        </p>
        <p>
          3.2.7. A <strong>STARTSE</strong> lembrará cada marco por meio do canal do Concierge,
          mas a responsabilidade pelo cumprimento é exclusiva do Participante. O descumprimento
          de qualquer um dos 5 (cinco) marcos extingue o direito à garantia,
          independentemente da participação nas demais frentes.
        </p>

        <p>
          <strong>3.3. Regra 3 — Aplicação prática: Relatório de Conclusão.</strong>
        </p>
        <p>
          3.3.1. Para acionar a garantia, o Participante deverá demonstrar que houve tentativa
          real de aplicar o conteúdo, por meio do envio de Relatório de Conclusão contendo:
        </p>
        <p>
          a) lista das ferramentas de IA testadas durante os 180 (cento e oitenta) dias, com
          data do teste e responsável interno;
        </p>
        <p>
          b) pelo menos 2 (dois) casos de uso piloto implementados, ainda que parcialmente, em
          alguma área da empresa;
        </p>
        <p>
          c) cálculo do retorno esperado de cada caso (payback, redução de custo ou aumento de
          receita projetados em 12 (doze) meses), demonstrando que nenhum atingiu R$ 12.000,00
          (doze mil reais);
        </p>
        <p>
          d) descrição das barreiras encontradas (técnicas, organizacionais ou de mercado) que
          impediram o ROI; e
        </p>
        <p>
          e) declaração formal do sponsor C-Level (Marco 4) confirmando as informações do
          Relatório.
        </p>
        <p>
          3.3.2. Sem evidência de que o Participante tentou aplicar o conteúdo, não há como
          distinguir falta de ROI de falta de execução, motivo pelo qual o Relatório protege
          tanto o Participante quanto a <strong>STARTSE</strong>.
        </p>

        <p id="4">
          <strong>4. COMO SOLICITAR O REEMBOLSO:</strong>
        </p>

        <p>
          <strong>4.1. Janela de solicitação.</strong>
        </p>
        <p>
          4.1.1. O Participante terá uma janela de 30 (trinta) dias para protocolar a
          solicitação, observado o seguinte:
        </p>
        <p>
          a) a solicitação não poderá ser feita antes do dia 181 (cento e oitenta e um), isto é,
          antes do término dos 180 (cento e oitenta) dias de programa;
        </p>
        <p>
          b) a solicitação não poderá ser feita após o dia 210 (duzentos e dez), sob pena de
          extinção do direito.
        </p>

        <p>
          <strong>4.2. Passo a passo.</strong>
        </p>
        <p>
          4.2.1. O Participante deverá encaminhar o Relatório de Conclusão para o e-mail
          garantia@startse.com, com o assunto “GARANTIA ROI – AI JOURNEY 2026 – [nome completo
          do Participante]”.
        </p>
        <p>
          4.2.2. A <strong>STARTSE</strong> confirmará o recebimento em até 5 (cinco) dias úteis.
        </p>
        <p>
          4.2.3. Comitê interno da <strong>STARTSE</strong> (Produto, Comercial e Jurídico)
          avaliará a solicitação em até 20 (vinte) dias úteis.
        </p>
        <p>
          4.2.4. Se necessário, a <strong>STARTSE</strong> poderá agendar reunião de validação
          com o Participante.
        </p>
        <p>
          4.2.5. A decisão será comunicada por escrito, com justificativa, no prazo de até 25
          (vinte e cinco) dias úteis contados do protocolo.
        </p>

        <p>
          <strong>4.3. Contestação da decisão.</strong>
        </p>
        <p>
          4.3.1. Caso o Participante discorde da decisão do comitê, poderá apresentar
          contestação por escrito em até 5 (cinco) dias úteis após o recebimento da resposta,
          pelo mesmo canal (garantia@startse.com).
        </p>
        <p>
          4.3.2. A <strong>STARTSE</strong> analisará a contestação em até 10 (dez) dias úteis
          adicionais.
        </p>

        <p>
          <strong>4.4. Prazo e valor do reembolso.</strong>
        </p>
        <p>
          4.4.1. Aprovado o reembolso, este será processado em até 10 (dez) dias úteis contados
          da aprovação final.
        </p>
        <p>
          4.4.2. O valor devolvido corresponderá a 100% (cem por cento) do valor efetivamente
          pago pelo Participante, sem qualquer dedução.
        </p>

        <p id="5">
          <strong>5. QUANDO A GARANTIA NÃO SE APLICA:</strong>
        </p>
        <p>
          5.1. Para total transparência, a garantia não será devida nas seguintes hipóteses:
        </p>
        <p>
          a) o Participante não cumpriu algum dos 5 (cinco) marcos obrigatórios (diagnóstico,
          roadmap, imersão, sponsor C-Level ou encontros ao vivo);
        </p>
        <p>
          b) o Participante não atingiu 80% (oitenta por cento) de participação na média
          ponderada das 5 (cinco) frentes do programa;
        </p>
        <p>
          c) o Participante saiu da empresa antes do 180º (centésimo octogésimo) dia sem indicar
          substituto C-Level que assumisse o programa nos 30 (trinta) dias seguintes;
        </p>
        <p>
          d) foram detectadas informações falsas ou indícios de má-fé no Relatório de Conclusão;
        </p>
        <p>
          e) o Participante está inadimplente com o pagamento do programa na data da
          solicitação;
        </p>
        <p>
          f) a solicitação foi protocolada fora da janela prevista (antes do dia 181 ou após o
          dia 210); ou
        </p>
        <p>
          g) o Participante compartilhou ou revendeu o acesso ao programa a terceiros não
          autorizados.
        </p>
        <p>
          5.2. Reconhecendo que cada empresa tem sua própria dinâmica, caso o Participante
          enfrente obstáculos organizacionais relevantes durante o programa, deverá entrar em
          contato com o Concierge antes do término dos 180 (cento e oitenta) dias. A{" "}
          <strong>STARTSE</strong> poderá, a seu critério, avaliar alternativas de suporte.
          Situações documentadas e comunicadas tempestivamente serão consideradas na análise do
          Relatório de Conclusão.
        </p>

        <p id="6">
          <strong>6. TRATAMENTO DE DADOS PESSOAIS (LGPD):</strong>
        </p>
        <p>
          6.1. Os dados pessoais e empresariais coletados durante o programa (incluindo
          diagnóstico de maturidade, roadmap, casos de uso e informações financeiras para
          cálculo de ROI) serão tratados pela <strong>STARTSE</strong> exclusivamente para as
          seguintes finalidades:
        </p>
        <p>a) execução do contrato e entrega do programa AI Journey 2026;</p>
        <p>b) análise das solicitações de reembolso no âmbito desta Garantia de ROI; e</p>
        <p>
          c) melhoria contínua dos produtos e serviços da <strong>STARTSE</strong>, sempre de
          forma anonimizada.
        </p>
        <p>
          6.2. O tratamento de dados observará as disposições da Lei Geral de Proteção de Dados
          (Lei nº 13.709/2018). Para exercer os direitos de acesso, correção, portabilidade ou
          eliminação de dados, o Participante deverá consultar a Política de Privacidade
          completa em startse.com/privacidade ou entrar em contato pelo e-mail
          privacidade@startse.com.
        </p>

        <p id="7">
          <strong>7. DISPOSIÇÕES GERAIS:</strong>
        </p>
        <p>
          7.1. <u>Foro:</u> fica eleito o foro do domicílio do Participante para dirimir
          quaisquer controvérsias decorrentes deste termo, sem prejuízo do direito de o
          Participante acionar o Juizado Especial Cível da sua localidade.
        </p>
        <p>
          7.2. <u>Lei aplicável:</u> o presente termo é regido pelas leis brasileiras, em
          especial pelo Código de Defesa do Consumidor (Lei nº 8.078/1990) e pelo Código Civil
          (Lei nº 10.406/2002).
        </p>
        <p>
          7.3. <u>Vigência:</u> este termo entra em vigor na data do aceite eletrônico pelo
          Participante e permanece vigente pelo período do programa e durante o prazo de
          solicitação da garantia (até o dia 210, contado do início do programa).
        </p>
        <p>
          7.4. <u>Registro do aceite:</u> o aceite eletrônico será registrado com data, hora e
          identificação do Participante, constituindo prova de ciência e concordância com todos
          os termos aqui estabelecidos.
        </p>

        <p id="resumo">
          <strong>RESUMO — O QUE O PARTICIPANTE PRECISA FAZER:</strong>
        </p>
        <p>Para ter direito à garantia, o Participante deverá cumprir os seguintes itens:</p>
        <p>a) atingir 80% (oitenta por cento) de participação na média ponderada do programa;</p>
        <p>b) realizar o Diagnóstico de Maturidade nos primeiros 30 (trinta) dias;</p>
        <p>c) validar o Roadmap de Adoção nos primeiros 60 (sessenta) dias;</p>
        <p>d) indicar um sponsor C-Level nos primeiros 30 (trinta) dias;</p>
        <p>
          e) participar de pelo menos 1 (uma) imersão presencial dentro dos 180 (cento e
          oitenta) dias;
        </p>
        <p>
          f) realizar pelo menos 10 (dez) sessões ao vivo distribuídas nos 180 (cento e oitenta)
          dias;
        </p>
        <p>g) testar pelo menos 2 (dois) casos de uso de IA na empresa do Participante; e</p>
        <p>
          h) enviar o Relatório de Conclusão entre os dias 181 (cento e oitenta e um) e 210
          (duzentos e dez).
        </p>
      </Content>
      <BackToTop />
    </Container>
  );
};

export default AIJourney_v1;
